module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_vm._v("A")]), _vm._v("LT")]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    style: ('background: ' + _vm._.get(_vm.barraAmbiente(), 'cor'))
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "x-large",
      "line-height": "45px"
    }
  }, [_vm._v(_vm._s(_vm._.get(_vm.barraAmbiente(), 'descricao')))]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.usuarioLogado.sujeitoAPonto) ? _c('li', {
    staticStyle: {
      "padding": "15px 15px"
    },
    attrs: {
      "data-title": _vm.minutosRestanteNoPonto > 5 ? 'Horário previsto para saída' : _vm.minutosRestanteNoPonto > 0 ? 'Sua jornada de trabalho está se encerrando' : 'Fim da jornada de trabalho'
    }
  }, [_c('span', {
    class: _vm.minutosRestanteNoPonto > 10 ? 'ponto-normal' : _vm.minutosRestanteNoPonto > 0 ? 'ponto-alerta' : 'ponto-perigo',
    staticStyle: {
      "font-weight": "bold",
      "padding": "8px 10px",
      "border-radius": "20px",
      "cursor": "default"
    }
  }, [_c('svg', {
    staticStyle: {
      "vertical-align": "middle",
      "width": "25px",
      "height": "25px",
      "display": "inline"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 000-1.5h-3.25V5z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n            " + _vm._s(_vm.usuarioLogado.limitePonto.slice(0, 2)) + "h" + _vm._s(_vm.usuarioLogado.limitePonto.slice(3, 5)) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [(_vm._.isNull(_vm.usuarioLogado.bl_foto)) ? _c('img', {
    staticClass: "user-image",
    attrs: {
      "src": '/static/img/nouser.png',
      "alt": "User Image pequeno"
    }
  }) : _c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.usuarioLogado.bl_foto,
      "alt": "User Image pequeno"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.usuarioLogado.ds_nome_usuario))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.usuarioLogado.bl_foto ? _vm.usuarioLogado.bl_foto : '/static/img/nouser.png',
      "alt": "User Image grande"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.usuarioLogado.userName) + "\n                "), _c('small', [_vm._v("Criado em: " + _vm._s(_vm._f("moment")(_vm.usuarioLogado.dt_criado, "DD-MM-YYYY")))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "to": {
        name: 'preferencias'
      },
      "uib-tooltip": "",
      "type": "button"
    }
  }, [_c('i', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Preferências")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Sair")])])])])]), _vm._v(" "), (_vm.usuarioLogado.ds_tipo_usuario === 'FUNDACAO') ? _c('li', [_vm._m(1)]) : _vm._e()])])]), _vm._v(" "), _c('vue-snotify'), _vm._v(" "), _c('dialog', {
    ref: "alertaPontoDialog",
    attrs: {
      "id": "alertaPontoDialog"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.minutosRestanteNoPonto <= 0) ? _c('p', {
    staticStyle: {
      "margin": "25px 0"
    }
  }, [_vm._v("\n      Jornada de trabalho encerrada.\n    ")]) : _c('p', {
    staticStyle: {
      "margin": "25px 0"
    }
  }, [_vm._v("\n      Em breve sua jornada de trabalho se encerrará.\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-neutral",
    attrs: {
      "onclick": "alertaPontoDialog.close()"
    }
  }, [_vm._v("Fechar")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "control-sidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Atenção!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3689cbf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 1903
// module chunks = 1